import { useState } from 'react';
import { Separator } from '@savvy-kit/components/separator';
import { Text } from '@savvy-kit/foundations/text';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { EXTERNAL_ACCOUNT_DATA_DISCLOSURE, EXTERNAL_ACCOUNT_DATA_DISCLOSURE_HEADING } from 'src/constants/portfolio';

import { textColors } from '@savvy/deprecated-shared/theme';

export function ExternalAccountDisclosure() {
  const [expand, setExpand] = useState(false);
  return (
    <>
      <div
        className="flex flex-row items-center cursor-pointer"
        onClick={() => {
          setExpand(!expand);
        }}
      >
        <Text variant="subtitle-sm" color="secondary" className="mr-2">
          {EXTERNAL_ACCOUNT_DATA_DISCLOSURE_HEADING}
        </Text>
        {expand ? <ChevronUp color={textColors.secondary} /> : <ChevronDown color={textColors.secondary} />}
      </div>
      {expand && (
        <>
          <Separator className="my-4 bg-border-light" />
          <Text variant="caption" color="secondary">
            {EXTERNAL_ACCOUNT_DATA_DISCLOSURE}
          </Text>
        </>
      )}
      {!expand && <div className="mb-[80.8px]" />}
    </>
  );
}
